import script from "./ConvDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConvDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./ConvDrawer.vue?vue&type=style&index=0&id=5f06e5dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f06e5dc"]])

export default __exports__